export const baseApiUrl = process.env.VUE_APP_BASE_API_URL
export const sandboxApi = process.env.VUE_APP_ACCESS_TOKEN
export const deployPath = process.env.VUE_APP_DEPLOY_PATH
// export const baseApiUrl = 'http://localhost:4010'

// Status da OS. Espelha ORDER_STATUS do backend (src/model/os.js).
export const ORDER_STATUS = {
  PENDING: 'PENDENTE',
  SCHEDULED: 'PROGRAMADO',
  STARTED: 'INICIADO',
  EXECUTED: 'EXECUTADO',
  // Atribuido pela API quando todos os RDOs da OS foram assinados pelo
  // Encarregado e pela Gerenciadora. Nao e selecionavel a mao.
  EXECUTED_SIGNED: 'EXECUTADO_ASSINADO',
  CANCELED: 'CANCELADO',
}

// So os status cujo valor gravado no banco nao serve para exibicao entram aqui.
// Os demais passam direto, para nao rotular a mao o que ja e legivel - e para
// nao renomear em tela um status que a base guarda com outro texto.
export const ORDER_STATUS_LABELS = {
  // EXECUTADO e o estado da OS executada cujos RDOs ainda nao foram todos
  // assinados; o rotulo deixa isso explicito para quem acompanha as pendencias.
  [ORDER_STATUS.EXECUTED]: 'EXECUTADO - SEM ASSINATURA',
  [ORDER_STATUS.EXECUTED_SIGNED]: 'EXECUTADO - ASSINADO',
}

// EXECUTADO_ASSINADO e um EXECUTADO ja assinado por ambas as partes: onde a
// tela pergunta "a OS foi executada?", os dois valem.
export const EXECUTED_STATUSES = [ORDER_STATUS.EXECUTED, ORDER_STATUS.EXECUTED_SIGNED]

export const isExecutedStatus = (status) =>
  EXECUTED_STATUSES.includes(String(status || '').trim().toUpperCase())

export const getOrderStatusLabel = (status) => {
  const normalized = String(status || '').trim().toUpperCase()
  return ORDER_STATUS_LABELS[normalized] || String(status || '')
}

// Rotulo + classe do badge de status da OS, para que as telas nao repitam o
// ternario "EXECUTADO ? verde : amarelo" - que passaria batido no assinado.
export const getOrderStatusBadge = (status) => {
  const normalized = String(status || '').trim().toUpperCase()

  const badgeClass =
    normalized === ORDER_STATUS.EXECUTED_SIGNED ? 'bg-emerald-600 text-white'
      : normalized === ORDER_STATUS.EXECUTED ? 'bg-green-100 text-green-700'
        : normalized === ORDER_STATUS.CANCELED ? 'bg-red-100 text-red-700'
          : 'bg-yellow-100 text-yellow-700'

  return { label: getOrderStatusLabel(status), badgeClass }
}

// A API devolve caminho relativo (/uploads/...), mas ela roda em outra origem que
// a do app. Um src relativo resolve contra o proprio app e a imagem nunca carrega
// - inclusive na impressao, que abre em janela separada.
// Todo arquivo servido pela API deve passar por aqui.
export const buildUploadUrl = (file) => {
  const rawUrl = file?.fileUrl || file?.url || (file?.fileName ? `/uploads/${file.fileName}` : null)
  if (!rawUrl) return null

  if (/^(https?:|data:|blob:)/i.test(rawUrl)) {
    return rawUrl
  }

  const normalizedBaseUrl = String(baseApiUrl || '').replace(/\/$/, '')
  return rawUrl.startsWith('/') ? `${normalizedBaseUrl}${rawUrl}` : `${normalizedBaseUrl}/${rawUrl}`
}
